export default __webpack_public_path__ + "static/favicon-db2d1d9043ecddab1c0f47bc365de2bf.png";